import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/step1.svg")